import { render, staticRenderFns } from "./VxTable.vue?vue&type=template&id=d7fd0306&"
import script from "./VxTable.vue?vue&type=script&lang=js&"
export * from "./VxTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports